export const DEFAULT_REQUIRED_FIELD_ERROR_MESSAGE = "This field is required"

export const checkRequired = <T extends { $dirty: boolean; required?: boolean }>(
  property: T,
  errorMessage = DEFAULT_REQUIRED_FIELD_ERROR_MESSAGE
) => (property.$dirty && !property.required ? [errorMessage] : [])
